

















import { Component, Vue, Prop } from "vue-property-decorator";
import { State } from "vuex-class";

@Component
class IconDefi extends Vue {
  @Prop({ type: Boolean, default: false }) pure;

  @State(state => state.app.bottomNav) currentNav;

  @State(state => state.app.settings.dark) isDark;

  get colors() {
    if (this.pure) {
      return ["", "currentColor", "currentColor", "currentColor"];
    }

    const active = this.$vuetify.theme.currentTheme.primary;
    const inactive = this.$vuetify.theme.currentTheme.grayscale_4;

    return this.currentNav === "defi" ? [active] : [inactive];
  }
}
export default IconDefi;
